module.exports = __webpack_public_path__ + "img/carousel-clientes-19.cb2a5b7f.png";